const res={
'data':[
{
'id': '1'
,'Date':'31-Jan-2022'
,'publication': "Python in Plain  English "
,'title': "10 VS Code Extensions for Python Programmers"
,'body': 'Here I am going to share 10 VS Code extensions to start programming in Python and a Bonus extension in the end!'
,'link':"https://medium.com/python-in-plain-english/top-10-vs-code-extensions-for-python-programmers-6ba6ddc22ba0"
},
{
'id': '2'
,'Date':'11-Jan-2022'
,'publication': "Bits and Pieces "
,'title': "How to Deploy JavaScript Apps with Netlify"
,'body': 'In this article, I have shared steps to deploy a JavaScript project to Netlify using either a GitHub repo or with local computer files.'
,'link':"https://medium.com/bitsrc/deploying-javascriptwebsites-using-netlify-a8bf40c9b39c"
},
{
'id': '3'
,'Date':'17-Jan-2022'
,'publication': "Bits and Pieces"
,'title': "Top VS Code Extensions for Web Development"
,'body': 'Must-have VS Code Extensions that all Web Developers should have installed'
,'link':"https://medium.com/bitsrc/most-important-vs-code-extensions-for-beginners-be75eb374d7d"
},
{
'id': '4'
,'Date':'11-Jan-2022'
,'publication': "TowardsDev"
,'title': "Deploying ReactJS WebSites Using Netlify"
,'body': 'React is a free and open-source front-end JavaScript library for building user interfaces based on UI components. React is widely used as a base in the development of single-page or mobile applications But deploying ReactJS projects have been a task well known.'
,'link':"https://medium.com/towardsdev/deploying-reactjs-websites-using-netlify-78e538342c72"
},
{
'id': '5'
,'Date':'04-Mar-2022'
,'publication': "KhushiBhambri"
,'title': "Top Beginner Friendly Web Development Projects using APIs"
,'body': 'In this article, I have discussed some amazing beginner Friendly Web development Projects using APIs. I have also Shared links to free APIs for these mini projects.'
,'link':"https://medium.com/@KhushiBhambri/top-beginner-friendly-projects-using-apis-f43356aeac7f"
}

]
}


export default res
